import React from "react";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Checkbox
} from "@mui/material";
import { Controller } from "react-hook-form";

const permissionsList = [
  "add",
  "view",
  "edit",
  "delete",
  "allaccess",
  "noaccess"
];

const PermissionsTable = ({
  control,
  permissionsData,
  handlePermissionChange,
  disabledCategories = []
}) => {
  const isDisabled = (category, perm) => {
    return (
      disabledCategories.includes(category) &&
      (perm === "add" ||
        perm === "view" ||
        perm === "edit" ||
        perm === "delete")
    );
  };

  return (
    <TableContainer>
      <Table className="role-permission-table">
        <TableHead>
          <TableRow>
            <TableCell>Category</TableCell>
            {permissionsList.map((perm) => {
              const formattedPerm = perm
                .toLowerCase()
                .replace("allaccess", "All Access")
                .replace("noaccess", "No Access");
              return (
                <TableCell key={perm} className="role-table-fonts">
                  {formattedPerm.charAt(0).toUpperCase() +
                    formattedPerm.slice(1)}
                </TableCell>
              );
            })}
          </TableRow>
        </TableHead>
        <TableBody>
          {Object.keys(permissionsData).map((category) => (
            <TableRow key={category}>
              <TableCell>{category}</TableCell>
              {permissionsList.map((perm) => (
                <TableCell key={perm} className="checkbox-cell">
                  <Controller
                    name={`permissions.${category}.${perm}`}
                    control={control}
                    render={({ field }) => (
                      <Checkbox
                        {...field}
                        checked={
                          perm === "allaccess"
                            ? field.value
                            : isDisabled(category, perm)
                            ? false
                            : field.value
                        }
                        onChange={(e) =>
                          handlePermissionChange(
                            category,
                            perm,
                            e.target.checked
                          )
                        }
                        disabled={
                          disabledCategories.includes(category) &&
                          (perm === "add" ||
                            perm === "view" ||
                            perm === "edit" ||
                            perm === "delete")
                        }
                        sx={
                          isDisabled(category, perm)
                            ? {
                                color: "rgba(0, 0, 0, 0.26)",
                                opacity: 0.5,
                                "& .MuiCheckbox-root": {
                                  color: "rgba(0, 0, 0, 0.26)"
                                }
                              }
                            : {}
                        }
                      />
                    )}
                  />
                </TableCell>
              ))}
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
};

export default PermissionsTable;
